import {useCallback, useState} from 'react';
import {arePreferredPlacesModified} from '@services/calendar/availability.service';

type InitialPreferredPlaces = {
    ids: number[];
    agreement: boolean;
};

type UsePreferredPlacesTrackingReturn = {
    preferredPlacesModified: boolean;
    setPreferredPlacesModified: (modified: boolean) => void;
    initialPreferredPlaces: InitialPreferredPlaces;
    setInitialPreferredPlaces: (places: InitialPreferredPlaces) => void;
    handlePreferredPlacesChange: (selectedPlaces: any[], agreementForOuterPlaces: boolean, setValue: (name: string, value: any, options?: any) => void) => void;
};

export const usePreferredPlacesTracking = (): UsePreferredPlacesTrackingReturn => {
    const [preferredPlacesModified, setPreferredPlacesModified] = useState(false);
    const [initialPreferredPlaces, setInitialPreferredPlaces] = useState<InitialPreferredPlaces>({
        ids: [],
        agreement: false,
    });

    const handlePreferredPlacesChange = useCallback(
        (selectedPlaces: any[], agreementForOuterPlaces: boolean, setValue: (name: string, value: any, options?: any) => void) => {
            const ids = selectedPlaces.map((p) => p.id);

            setValue('preferredPlacesOfService', ids, {shouldDirty: true});
            setValue('agreementForOuterPlaces', agreementForOuterPlaces, {shouldDirty: true});

            const hasChanged = arePreferredPlacesModified(
                ids,
                initialPreferredPlaces.ids,
                agreementForOuterPlaces,
                initialPreferredPlaces.agreement
            );

            setPreferredPlacesModified(hasChanged);
        },
        [initialPreferredPlaces]
    );

    return {
        preferredPlacesModified,
        setPreferredPlacesModified,
        initialPreferredPlaces,
        setInitialPreferredPlaces,
        handlePreferredPlacesChange,
    };
};
